<template>
  <div class="col-sm-12 nopads list-container">
    <Transition name="fade">
      <div
        v-if="items.length > 0"
        id="accordion"
        class="col-sm-12 list-content result-table"
      >
          <vue3-datatable
              ref="resultTable"
              :rows="items"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="emitDetails"
          >
              <template #start_time="row">
                  {{ row.value && row.value.start_time ? toLocalTime(row.value.start_time) : '' }}
              </template>
              <template #end_time="row">
                  {{ row.value && row.value.end_time ? toLocalTime(row.value.end_time) : '' }}
              </template>

          </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'WorkReportList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'start_time',
            sortDesc: true,
            items: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('work_report.report_id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'start_time', title: this.$t('work_report.start_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'end_time', title: this.$t('work_report.end_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'customer', title: this.$t('work_report.customer'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract', title: this.$t('work_report.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'task_type', title: this.$t('work_report.task_type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'reporter', title: this.$t('work_report.reporter'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        results: function () {
            this.initTableItems()
        }
    },
    mounted: function () {
        this.initTableItems()
    },
    methods: {
        initTableItems: function () {
            this.items = []
            this.results.forEach(function (item) {
                this.items.push(
                    {
                        id: item.id,
                        start_time: item.start_time,
                        end_time: item.end_time,
                        customer: item.order.contract.customer.name,
                        contract: item.order.contract.name,
                        task_type: item.order.task_type.name,
                        reporter: item.reporter.first_name + ' ' + item.reporter.last_name,
                    }
                )
            }, this)
        },
        emitDetails: function (details) {
            let report = this.results.find(item => item.id === details.id)
            this.$emit('details', report)
        }
    }
}
</script>
